import { useLingui } from '@lingui/react/macro';

import {
  FilterCheckboxItem,
  FiltersList,
  FiltersSubMenu,
} from '@/design_system/Filters/FiltersDrawer/FiltersDrawer';
import IconStep from '@/icons/Step.svg';
import { SHIPMENT_STEPS } from '@/models/shipment';

import { useFilters } from '../FiltersState';

export const FiltersStep = () => {
  const { t, i18n } = useLingui();

  const {
    steps: { steps, setSteps },
  } = useFilters();

  const toggleStep = (step: (typeof steps)[number]) => {
    if (steps.includes(step)) {
      setSteps(steps.filter((s) => s !== step));
    } else {
      setSteps([...steps, step]);
    }
  };

  return (
    <FiltersSubMenu
      id="step"
      icon={<IconStep />}
      label={t({ id: 'shipments.filters.step.label', message: 'Step' })}
      count={steps.length}
    >
      <FiltersList
        ariaLabel={t({ id: 'shipments.filters.step.label', message: 'Step' })}
        values={steps}
        onChange={toggleStep}
      >
        {SHIPMENT_STEPS.map(({ id, name }) => (
          <FilterCheckboxItem key={id} id={id} label={i18n._(name)} />
        ))}
      </FiltersList>
    </FiltersSubMenu>
  );
};
